export default "__VITE_ASSET__7XmQsbuV__"